import { render } from "./SubKategori.vue?vue&type=template&id=7a03957d"
import script from "./SubKategori.vue?vue&type=script&lang=js"
export * from "./SubKategori.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__